<ng-container *ngIf="applicationsConfig" [formGroup]="applicationsForm">
  <div class="applications-form" fxLayout="row wrap"  fxFlex="100">
    <ng-container *ngIf="!disabled">
      <ng-container *ngFor="let permission of applicationsConfig.applications;">
        <mat-form-field class="applications-form-field" fxFlex="50">
          <mat-label>{{ permission.displayName }}</mat-label>
          <mat-select [required]="false" [formControlName]="permission.module">
            <mat-option *ngFor="let role of permission.roles" [value]="role">
              {{applicationsConfig.roles[role]}}
            </mat-option>
          </mat-select>
          <button *ngIf="applicationsForm.get(permission.module).value"
                  matSuffix
                  mat-icon-button
                  type="button"
                  aria-label="Clear"
                  (click)="applicationsForm.get(permission.module).setValue(null); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="disabled">
      <ng-container *ngFor="let permission of applicationsConfig.applications;">
        <div class="applications-form-field" fxFlex="50">
          <app-detail [header]="permission.displayName" [value]="applicationsConfig.roles[currentApplications[permission.module]] ?
                      applicationsConfig.roles[currentApplications[permission.module]] : 'Brak dostępu'"></app-detail>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
